'use client';

import { useFormStatus } from 'react-dom';
import { IconLoading02 } from 'icon/General/loading-02';
import { Button, type ButtonProps } from './button';

export type SubmitButtonProps = ButtonProps & {
  icon?: React.ReactNode;
  loading?: boolean;
};

export function SubmitButton({
  children,
  disabled,
  loading,
  icon,
  ...props
}: SubmitButtonProps) {
  const { pending } = useFormStatus();
  return (
    <Button disabled={loading || pending || disabled} type="submit" {...props}>
      {loading || pending ? (
        <IconLoading02 className="size-5 animate-spin" />
      ) : (
        icon
      )}
      {children}
    </Button>
  );
}
